/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import PropTypes from 'prop-types';

const Button = ({
  label,
  onClick,
  type,
  href,
  disabled,
  buttonClasses,
  iconPosition,
  iconClasses,
  target,
}) => {
  return type === 'link'
    ? (
      <a
        className={`btn ${buttonClasses}`}
        href={href}
        disabled={disabled}
        target={target}
        onClick={onClick}>
        {iconPosition === 'before' && <span className={`${iconClasses} -before`} />}
        {label}
        {iconPosition === 'after' && <span className={`${iconClasses} -after`} />}
      </a>
    )
    : (
      <button
        className={`btn ${buttonClasses}`}
        // Next line is disabled so we can use tue button as submit or simple bnt.
        // eslint-disable-next-line react/button-has-type
        type={type}
        disabled={disabled}
        onClick={onClick}>
        {
          iconPosition === 'before'
          && iconClasses !== ''
          && <span className={`${iconClasses} -before`} />
        }
        {label}
        {
          iconPosition === 'after'
          && iconClasses !== ''
          && <span className={`${iconClasses} -after`} />
        }
      </button>
    );
};

Button.defaultProps = {
  onClick: () => { },
  type: 'button',
  href: '',
  disabled: false,
  buttonClasses: '',
  iconPosition: 'after',
  iconClasses: '',
  target: '',
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  buttonClasses: PropTypes.string,
  iconPosition: PropTypes.string,
  iconClasses: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
};

export default Button;
/* eslint-enable jsx-a11y/anchor-is-valid */
